import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';

import { productLinks } from 'settings';

/**
 * @typedef StoreButtonsProps
 * @property {boolean} title Whether to display a default title
 */

/**
 * Renders a small box with buttons linking to the mobile app's android and ios pages
 * 
 * @param {StoreButtonsProps} param0 StoreButtons props
 * @returns {JSX.Element} StoreButtons component
 */
const StoreButtons = ({title = false}) => (
  <React.Fragment>
    {title && <h3>{i18n.translate('storeButtons.title')}</h3>}
    <div className="storeButtons__container">
      <a href={productLinks.ios} target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={['fab', 'app-store']} />
      </a>
      <a href={productLinks.android} target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={['fab', 'google-play']} />
      </a>
    </div>
  </React.Fragment>
  );

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};